import React from 'react'

export const audioHasNoSource = audio => {
  return !audio.currentSrc || audio.currentSrc.length === 0
}
